import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import './styles.css';
import { CommonConfig } from '../../config/common-config';
import { userType } from '../../config/usertypeValue';
import LoaderPopUp from '../../components/loaderpopup/loader';

const useStyles = makeStyles({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
    },
    paperGreen: {
        padding: '16px',
        textAlign: 'center',
        borderBottom: '4px solid green',
    },
    paperOrange: {
        padding: '16px',
        textAlign: 'center',
        borderBottom: '4px solid orange',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },

    pos: {
        marginBottom: 12,
    },
    cardCustom: {
        padding: '0 !important',
    },
    fullWidth: {
        width: '100%',
        marginTop: '5%',
        position: 'fixed',
        left: '0',
        bottom: '0',
    },
    mb20: {
        marginBottom: '20px',
    },
});

export default function TabList(props) {
    const location = useLocation();
    const statusIDView = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const tennantName = tennantnameValue && tennantnameValue.toUpperCase();
    const [checklist, setChecklist] = useState('');
    const [statusFlag, setStatusFlag] = useState(true);
    const statusID = checklist && checklist.currentStage.id;
    const [paidTax, setPaidTax] = useState('');
    const [locationPath, setLocationPath] = useState('');
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        const locationPathName = location.state && location.state.path;
        setLocationPath(locationPathName);
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected}/${serviceIdValue}/6`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    userType.checklistFlag = false;
                } else {
                    userType.checklistFlag = true;
                }
            })
            .catch(() => { });

        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected}/${serviceIdValue}/11`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    userType.detailAnalysisFlag = false;
                } else {
                    userType.detailAnalysisFlag = true;
                }
            })
            .catch(() => { });

        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    setChecklist(response.data);
                }
            })
            .catch(() => { });
        if (userType.statusFlag) {
            getInitialStage();
        }

        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${tennantName === 'ADVITH' ? tennantnameValue : imcNameSelected}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setPaidTax(response.data.paidTax);
            })
            .catch(() => {
                setShowLoader(false);
            });
    }, [bearerToken, statusID, userType]);

    const getInitialStage = () => {
        // setShowLoader(true);

        userType.historyStageId = statusIDView
        if (statusID === 2 && usertype === 'Ultimate Client') {
            userType.value = 'L1 Checklist';
            navigateChecklist('/menu/checkListUltimate', 'L1 Checklist');
        }
        if (statusID === 4 && usertype === 'ITeC Team') {
            userType.value = 'L1 CRC Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed');
        }
        if (statusID === 5 && usertype === 'ITeC AM and above') {
            userType.value = 'L1 AM Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed');
        }
        if (statusID === 6 && usertype === 'Ultimate Client') {
            userType.value = 'L2 Checklist';
            navigateChecklist('/menu/checkListUltimate', 'L2 Checklist');
        }
        if (statusID === 8 && usertype === 'ITeC Team') {
            userType.value = 'L2 CRC Confirmed';
            navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed');
        }
        if (statusID === 10 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'EM Confirmed';
            navigateChecklist('/menu/crc-checklist', 'EM Confirmed');
        }
        if (statusID === 12 && usertype === 'ITeC Team') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('itec-detail-analysis-crc', 'Detailed Analysis');
        }
        if (statusID === 15 && usertype === 'ITeC AM and above') {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/itec-detail-analysis-am', 'Detailed Analysis');
        }
        if (statusID === 14 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/detail-analysis', 'Detailed Analysis');
        }
        if (statusID === 13 && usertype === "Other employee users") {
            userType.value = 'Detailed Analysis';
            navigateChecklist('/menu/detail-analysis', 'Detailed Analysis');
        }
        if ((statusID === 16 || statusID === 18) && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Draft Statements';
            navigateChecklist('/menu/imc-draft-document', 'Draft Statements');
        }
        if (statusID === 17 && usertype === 'Ultimate Client') {
            userType.value = 'Draft Statements';
            navigateChecklist('/menu/client-draft-document', 'Draft Statements');
        }
        if (statusID === 19 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Final Statement';
            navigateChecklist('/menu/imc-tax-payment', 'Final Statement');
        }
        if (statusID === 20 && usertype === 'Ultimate Client') {
            userType.value = 'Tax Payment and Filing by Client';
            navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing by Client');
        }
        if (statusID === 21 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Tax Payment and Filing';
            navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing');
        }
        if (statusID === 22 && (usertype === 'EM' || usertype === "Other employee users")) {
            userType.value = 'Reports';
            navigateChecklist('/menu/imc-reports', 'Reports');
        }
        if (statusID === 22 || statusID === 23 || statusID === 24 || statusID === 25 || statusID === 26 || statusID === 30 || statusID === 31 && usertype === 'Ultimate Client') {
            userType.value = 'Reports';
            navigateChecklist('/menu/client-final-doc-approval', 'Reports');
        }
        // setTimeout(() => {
        //     setShowLoader(false);
        // }, 7000);
    }

    const navigateChecklist = (path, typeValue) => {
        // setShowLoader(true);

        if (typeValue === 'L1 Checklist') {
            userType.historyStageId = 3
            setTimeout(() => {
                setShowLoader(false);
            }, 2000);
        }
        if (typeValue === 'L1 CRC Confirmed') {
            userType.historyStageId = 5
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
        }
        if (typeValue === 'L1 AM Confirmed') {
            userType.historyStageId = userType.checklistFlag ? 5 : 6;
            setTimeout(() => {
                setShowLoader(false);
            }, 7000);
        }
        if (typeValue === 'L2 Checklist') {
            userType.historyStageId = 7
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
        }
        if (typeValue === 'L2 CRC Confirmed') {
            userType.historyStageId = 10
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
        }
        if (typeValue === 'EM Confirmed') {
            userType.historyStageId = 10
            setTimeout(() => {
                setShowLoader(false);
            }, 3000);
        }
        userType.statusFlag = false;
        userType.value = typeValue;
        history.push
            ({
                pathname: path,
                state: { path: "openservices" }
            });

    }

    return (
        <>

            <div>
                {showLoader ? (<LoaderPopUp showLoader={showLoader} />) : null}

                {/* <span>{statusID}{usertype}</span> */}
                <div className="stage-indicator">
                    <ul>
                        {statusID === 2 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className="activetab">L1 Checklist</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 4 && usertype === 'ITeC Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className="activetab">L1 CRC Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 5 && usertype === 'ITeC AM and above' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className="activetab">L1 AM Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 6 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className="activetab">L2 Checklist</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 8 && usertype === 'ITeC Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className="activetab">L2 CRC Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 10 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className="activetab">EM Confirmed</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 12 && usertype === 'ITeC Team' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/itec-detail-analysis-crc', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 15 && usertype === 'ITeC AM and above' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/itec-detail-analysis-am', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 14 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 13 && usertype === "Other employee users" ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className="activetab">Detailed Analysis</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {(statusID === 16 || statusID === 18) && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' && locationPath != "openservices" ? 'active' : ''}>Detailed Analysis</li>
                                <li onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')} className="activetab">Draft Statements</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 17 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className="activetab">Draft Statements</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 19 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className="activetab">Final Statement</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 20 && usertype === 'Ultimate Client' ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                {/* <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li> */}
                                <li onClick={() => navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing by Client')} className="activetab">Tax Payment and Filing</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 21 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist('/menu/detailAnalysisCore', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                {/* <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li> */}
                                <li onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li>
                                <li onClick={() => navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing')} className="activetab">Tax Payment and Filing</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {statusID === 22 && (usertype === 'EM' || usertype === "Other employee users") ? (
                            <ul>
                                <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li>
                                <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li>
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> : null}
                                {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                <li onClick={() => navigateChecklist(userType.detailAnalysisFlag ? '/menu/detailAnalysisCore' : '/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li>
                                {/* <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li> */}
                                <li onClick={() => navigateChecklist('/menu/imc-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li>
                                <li onClick={() => navigateChecklist('/menu/imc-final-doc-approval', 'Tax Payment and Filing')} className={userType.value === 'Tax Payment and Filing' ? 'active' : ''}>Tax Payment and Filing</li>
                                <li onClick={() => navigateChecklist('/menu/imc-reports', 'Reports')} className="activetab">Reports</li>
                            </ul>
                        ) : (
                                ''
                            )}
                        {usertype === 'Ultimate Client' ?
                            statusID === 22 || statusID === 23 || statusID === 24 || statusID === 25 || statusID === 26 || statusID === 30 || statusID === 31 && usertype === 'Ultimate Client' ? (
                                <ul>
                                    <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L1 Checklist')} className={userType.value === 'L1 Checklist' ? 'active' : ''}>L1 Checklist</li>
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 CRC Confirmed')} className={userType.value === 'L1 CRC Confirmed' ? 'active' : ''}>L1 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L1 AM Confirmed')} className={userType.value === 'L1 AM Confirmed' ? 'active' : ''}>L1 AM Confirmed</li> */}
                                    {!userType.checklistFlag ? <li onClick={() => navigateChecklist('/menu/checkListUltimate', 'L2 Checklist')} className={userType.value === 'L2 Checklist' ? 'active' : ''}>L2 Checklist</li> : null}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'L2 CRC Confirmed')} className={userType.value === 'L2 CRC Confirmed' ? 'active' : ''}>L2 CRC Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/crc-checklist', 'EM Confirmed')} className={userType.value === 'EM Confirmed' ? 'active' : ''}>EM Confirmed</li> */}
                                    {/* <li onClick={() => navigateChecklist('/menu/detail-analysis', 'Detailed Analysis')} className={userType.value === 'Detailed Analysis' ? 'active' : ''}>Detailed Analysis</li> */}
                                    <li onClick={() => navigateChecklist('/menu/client-draft-document', 'Draft Statements')} className={userType.value === 'Draft Statements' ? 'active' : ''}>Draft Statements</li>
                                    {/* <li onClick={() => navigateChecklist('/menu/imc-tax-payment', 'Final Statement')} className={userType.value === 'Final Statement' ? 'active' : ''}>Final Statement</li> */}
                                    {paidTax === false ? <li onClick={() => navigateChecklist('/menu/client-tax-payment', 'Tax Payment and Filing by Client')} className={userType.value === 'Tax Payment and Filing by Client' ? 'active' : ''}>Tax Payment and Filing</li>
                                        : null}
                                    <li onClick={() => navigateChecklist('/menu/client-final-doc-approval', 'Reports')} className="activetab">Reports</li>
                                </ul>
                            ) : (
                                    ''
                                ) : ""}
                    </ul>
                </div>
            </div>
        </>
    );
}
